import React from 'react';
import { Header, PageContainer, PageContent, Sidebar } from '../../layouts';
import { Button, CheckBox, InputField, TextArea, TitleLarge } from '../../components';
import { DELETE_ICON, SAVE_ICON } from '../../utils/consts';

const WebCheckDetailPage = () => {
	return (
		<>
			<Header />
			<PageContainer>
				<Sidebar />
				<PageContent>
					<TitleLarge>Website-Prüfung "Google Page Speed"</TitleLarge>
					<div className='container my-5'>
						<div className='row justify-content-center'>
							<div className='col-12 col-sm-8 col-xl-7'>
								<form>
									<InputField
										id={'check_name'}
										classes={'background-secondary'}
										type={'text'}
										label={'Prüfung-Name'}
										value={'Google Page Speed'}
										onChange={() => {}}
									/>
									<TextArea
										id={'check_desc'}
										classes={'background-secondary'}
										style={{ minHeight: '150px', maxHeight: '200px' }}
										label={'Beschreibung'}
										value={
											'Fragt die Google PageSpeed API ab, holt die Werte für Leistung, Barrierefreiheit, Best Practices und SEO und prüft, ob die Mindestanforderungen dieser Werte erfüllt werden.'
										}
										onChange={() => {}}
									/>
									<InputField
										id={'check_method'}
										classes={'background-secondary'}
										type={'text'}
										label={'Check-Methode'}
										value={'googlepagespeed'}
										onChange={() => {}}
									/>
									<CheckBox
										id={'is_mandatory'}
										label={'Obligatorisch'}
										classes={'background-tertiary'}
									/>
									<CheckBox
										id={'is_deleted'}
										label={'Gelöscht'}
										classes={'background-tertiary'}
									/>
									<div className='d-flex justify-content-end mt-4 gap-3'>
										<Button
											classes={'background-red px-4 py-2'}
											icon={DELETE_ICON}>
											Löschen
										</Button>
										<Button
											classes={'background-blue px-4 py-2'}
											icon={SAVE_ICON}>
											Speichern
										</Button>
									</div>
								</form>
							</div>
						</div>
					</div>
				</PageContent>
			</PageContainer>
		</>
	);
};

export default WebCheckDetailPage;
